import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Stack } from '@mui/material';
import { BaseNode } from 'pages/assistants/builder/components/nodes/baseNode';
import { CompactNodeField } from 'pages/assistants/builder/components/nodes/compactNodeField';

export function LlmAdvisorNode({ id, data, handleConf, onEditNode, onDeleteNode }) {
  const { formatMessage: msg } = useIntl();

  return (
    <BaseNode
      id={id}
      icon="auto_awesome"
      nodeData={{ ...data, label: data?.label || 'Processeur' }}
      color="primary"
      handleConf={handleConf}
      onEditNode={onEditNode}
      onDeleteNode={onDeleteNode}
    >
      <Stack spacing={1} sx={{ p: 1, width: '280px' }}>
        <CompactNodeField
          label={msg({ id: 'field.provider.label' })}
          value={data?.providerCode || '-'}
          shrink={false}
        />
        <CompactNodeField
          label={msg({ id: 'field.model.label' })}
          value={data?.modelCode || '-'}
          shrink={false}
        />
      </Stack>
    </BaseNode>
  );
}

LlmAdvisorNode.propTypes = {
  id: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.string,
    providerCode: PropTypes.string,
    modelCode: PropTypes.string
  }),
  handleConf: PropTypes.array.isRequired,
  onEditNode: PropTypes.func.isRequired,
  onDeleteNode: PropTypes.func.isRequired
};
